import { render, staticRenderFns } from "./PlaylistsVideoPlayer.vue?vue&type=template&id=17474435&scoped=true"
import script from "./PlaylistsVideoPlayer.vue?vue&type=script&lang=js"
export * from "./PlaylistsVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./PlaylistsVideoPlayer.vue?vue&type=style&index=0&id=17474435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17474435",
  null
  
)

export default component.exports